import { createFileRoute } from '@tanstack/react-router';

import { CompanySetupPage } from '../../modules/company-setup/company-setup-page.js';

export const Route = createFileRoute('/company-setup/')({
  component: CompanySetupPage,
});
